<template lang="pug">
  include /mixins
  +b.g-row.relative().multisearch-scroll-content
    ui-loader.mini-loading(v-if='load')
    +b.g-cell.g-cols--12.--3-md.multisearch-scroll
      //- +b.multisearch-result-item(
      //-   v-if='meta.corrected'
      //- )
      //-   +b.ds-caption--size_xs.P(
      //-   ) {{ _('Показаны результаты по запросу') }} #[span(v-html='meta.corrected.highlight')]
      +b.multisearch-result-item.tt-link--variant_start.A(
        @click.prevent='setActive()'
        :class='{"is-active": !activeCategory }'
      )
        +e.title.SPAN {{ _('Все результаты') }}
        +e.count.SPAN {{ found.total }}
      +b.multisearch-result-item.tt-link--variant_start.A(
        v-for='link in categories'
        @click.prevent='setActive(link);'
        :class='{"is-active": activeCategory && activeCategory.id == link.id }'
      )
        +e.title.SPAN {{ link.props.title }}
        +e.count.SPAN {{ link.found.total }}
    +b.g-cell.g-cols--12.--9-md.multisearch-scroll-content(
      v-if='activeCategory'
    )
      +b.multisearch-preview
        //- +e.title--hidden.A(
        //-   :href='activeCategory.props.url'
        //- ) {{ activeCategory.props.title }}
        +e.list
          paginated-view(
            :key='activeCategory.id',
            :found='activeCategory.found'
            :resource='resource',
            :search='localsearch',
            :limit='$options.LIMIT_BY_CATEGORY'
            :category='activeCategory.id'
            @load:start='$emit("load:start")'
            @load:end='$emit("load:end")'
          )
            template(
              #default='{ splicedList, hasNext, hasPrev, getNext, getPrev }'
            )
              div()
                +b.g-row
                  +b.g-cell.g-cols--6.--6-md.--4-xl(
                    v-for='(link, t) in splicedList'
                  )
                    product-preview(
                      :link='link',
                      :t='t'
                      :findValueAndHighlightTerm='findValueAndHighlightTerm'
                      :highlightTerm='highlightTerm'
                      :localsearch='localsearch'
                      :trigger_overlay='trigger_overlay'
                    )
                +b.g-row--justify_end
                  +b.g-cell.g-cols
                    +b.circle-btn--light.controls--variant_bordered.--appearance_visible.A(
                      @click.prevent='getPrev'
                      v-show='hasPrev'
                    )
                      +e.icon.mdi.mdi-chevron-left
                  +b.g-cell.g-cols
                    +b.circle-btn--light.controls--variant_bordered.--appearance_visible.A(
                      @click.prevent='getNext',
                      v-show='hasNext'
                    )
                      +e.icon.mdi.mdi-chevron-right
    +b.g-cell.g-cols--12.--9-md.multisearch-scroll-content(
      v-else
    )
      +b.multisearch-preview(
      )
        //- +e.title.A(
        //-   :href='line.category.props.url'
        //- ) {{ line.category.props.title }}
        paginated-view(
          :list='results',
          key='all_results_view',
          :found='found'
          :limit='$options.LIMIT_BY_CATEGORY'
          @load:start='$emit("load:start")'
          @load:end='$emit("load:end")'
        )
          template(
            #default='{ splicedList, hasNext, hasPrev, getNext, getPrev }'
          )
            div()
              +b.g-row
                +b.g-cell.g-cols--6.--6-md.--4-xl(
                  v-for='(link, t) in splicedList'
                )
                  product-preview(
                    :link='link',
                    :t='t'
                    :findValueAndHighlightTerm='findValueAndHighlightTerm'
                    :highlightTerm='highlightTerm'
                    :localsearch='localsearch'
                    :trigger_overlay='trigger_overlay'
                  )
              +b.g-row--justify_end
                +b.g-cell.g-cols
                  +b.circle-btn--light.controls--variant_bordered.--appearance_visible.A(
                    @click.prevent='getPrev'
                    v-show='hasPrev'
                  )
                    +e.icon.mdi.mdi-chevron-left
                +b.g-cell.g-cols
                  +b.circle-btn--light.controls--variant_bordered.--appearance_visible.A(
                    @click.prevent='getNext',
                    v-show='hasNext'
                  )
                    +e.icon.mdi.mdi-chevron-right
</template>

<script>
import ProductPreview from '@app/Search-v3/Ui/Previews/Product'
import PaginatedView from '@app/Search-v3/Ui/PaginatedView'

const POPULAR_CATEGORIES_COUNT = 3
const POPULAR_PRODUCTS_COUNT = 4
const LIMIT_BY_CATEGORY = 12

export default {
  props: {
    findValueAndHighlightTerm: {},
    highlightTerm: {},
    results: {},
    localsearch: {},
    resource: {},
    load: {},
    found: {},
    categories: {},
    trigger_overlay: {},
  },
  components: {
    ProductPreview,
    PaginatedView,
  },
  LIMIT_BY_CATEGORY,
  POPULAR_PRODUCTS_COUNT,
  data() {
    return {
      activeCategory: '',
      list: [],
    }
  },
  watch: {
    results: {
      handler() {
        this.viewPopular()
        this.activeCategory = null
      },
    },
    immediate: false,
    deep: true,
  },
  computed: {
    totalCount() {
      return this.results.reduce((acc, obj) => {
        acc += obj.count
        return acc
      }, 0)
    },
  },
  mounted() {
    this.viewPopular()
  },
  methods: {
    setActive(category) {
      this.list = []
      this.activeCategory = category
    },
    viewPopular() {
      // this.list = JSON.parse(JSON.stringify(this.results)).splice(0, POPULAR_CATEGORIES_COUNT).reduce((acc, obj) => {
      //   obj.variants = obj.variants.splice(0, POPULAR_PRODUCTS_COUNT)
      //   acc.push(obj)
      //   return acc
      // }, [])
    },
    getCategoryAndSet(id) {
      const result = this.results.find(({ category }) => category.id === id)
      this.setActive(result)
    },
  },
}
</script>
